import React from "react";

export const BookmarkIcon = () => {
  return (
    <>
      <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.88285 11.1093L1.64935 13.7736C1.4961 13.8998 1.31397 13.9767 1.1233 13.9955C0.932627 14.0143 0.740975 13.9743 0.569785 13.88C0.398595 13.7857 0.254625 13.6408 0.153989 13.4616C0.0533526 13.2824 2.65041e-05 13.0758 0 12.8651V2.2701C0 1.66809 0.217254 1.09073 0.604002 0.665005C0.99075 0.239284 1.51529 7.58456e-05 2.06228 0H8.93772C9.48468 7.58456e-05 10.0093 0.239284 10.396 0.665005C10.7827 1.09073 11 1.66809 11 2.2701V12.8649C11 13.0756 10.9466 13.2821 10.846 13.4613C10.7454 13.6405 10.6014 13.7854 10.4302 13.8797C10.259 13.974 10.0674 14.014 9.8767 13.9952C9.68603 13.9764 9.5039 13.8995 9.35065 13.7732L6.119 11.1093C5.9406 10.9623 5.72377 10.8829 5.50093 10.8829C5.27808 10.8829 5.06122 10.9623 4.88285 11.1093Z" fill="#004F9F"/>
      </svg>    
    </>
  );
};
